import { Address, erc20Abi, zeroAddress } from "viem";
import { useAccount, useReadContract } from "wagmi";

interface UseIsContractAllowedToSpendTokenParams {
  amount?: bigint;
  token: Address;
  spender: Address;
  disabled?: boolean;
}

export const useERC20Allowance = ({
  token,
  spender,
  amount = 0n,
  disabled = false,
}: UseIsContractAllowedToSpendTokenParams) => {
  const { address = zeroAddress } = useAccount();
  const { data: allowance = 0n, ...rest } = useReadContract({
    address: token,
    scopeKey: "allowance",
    abi: erc20Abi,
    functionName: "allowance",
    args: [address, spender],
    query: {
      enabled: disabled || Boolean(address !== zeroAddress),
    },
  });

  return {
    allowance,
    isAllowed: amount <= allowance,
    ...rest,
  };
};
